import translateMixin from "@/components/mixins/translateMixin";

function getFlairServiceText(serviceId) {
    let index = _.findIndex(this.allServices, service => service.id === serviceId);
    return index !== -1 ? this.translateService(this.allServices[index].title) : '';
}

function getFlairServiceTextMobile(services) {
    const result = [];
    if (Array.isArray(services)) {
        services.forEach(serviceId => {
            result.push(this.getFlairServiceText(serviceId));
        });
    }
    return result.join(', ');
}

const data = () => ({
    store: $store,
});

export default {
    data,
    methods: {
        getFlairServiceText,
        getFlairServiceTextMobile,
    },
    mixins:[translateMixin],
    computed: {
        ...mapState(['allServices'])
    }
}
